module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "navbar is-black is-fixed-top has-shadow",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "progressbar-logo-container",
    attrs: {
      "to": "/"
    }
  }, [_c('progressbar-logo-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    attrs: {
      "role": "button",
      "aria-label": "menu",
      "aria-expanded": _vm.showNav
    },
    on: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showNav
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/place-for-your-community-meetup-in-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Community Meetups\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/rent-meeting-room-coworking-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Meeting Room\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/rent-flex-desk-coworking-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Rent Desk\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/rent-a-space-in-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Rent Venue\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/video"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Recordings\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown",
    class: {
      'is-active': _vm.showNav
    }
  }, [_c('a', {
    staticClass: "navbar-link is-size-4",
    on: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              Others\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown is-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/calendar"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              📅 Calendar\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/contact-venue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🛸 Contact\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/network"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🛰 Network\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/podcast"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🎙 Podcast\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/video"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🎥 Recordings\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/our-residents"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🏡 Residents\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/pay"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              💸 Support operations\n              ")]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/dvepercenta"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              📿 Donate 2 % of your taxes\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/call-for-the-sponsors"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🌈 Call for the Sponsors\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/crowdfunding"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              💰 Crowdfunding\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/give-us-review-thanks"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🥰 Give us Review\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/team"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🙏 Team\n              ")])], 1)])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d98bb546","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 93
// module chunks = 24